import React, { createContext, useState } from 'react'

const MenuContext = createContext()

const MenuProvider = ({ children }) => {
  const [selectedCategory, setSelectedCategory] = useState({ id: '', search: false, highlight: false })
  const [scrollPositions, setScrollPositions] = useState({})

  return (
    <MenuContext.Provider
      value={{
        scrollPositions,
        setScrollPositions,
        selectedCategory,
        setSelectedCategory,
      }}
    >
      {children}
    </MenuContext.Provider>
  )
}

export { MenuProvider }
export default MenuContext
